export interface Point {
    x: number;
    y: number;
}

export interface CanvasPath {
    id: string;
    points: Point[];
    convexHull: Point[];
    color: string;
    toConnectionId: string;
    timestamp: number;
}

export interface ErasePath {
    id: string;
    toConnectionId: string;
}

// Taken from https://github.com/indy256/convexhull-js
export function getConvexHull(points: Point[]) {
    // Create a copy of the points,
    // since the sort function modifies the array in place.
    const inputPoints = [...points];
    inputPoints.sort((a, b) => {
        return a.x !== b.x ? a.x - b.x : a.y - b.y;
    });

    var n = inputPoints.length;
    var hull = [];

    for (var i = 0; i < 2 * n; i++) {
        var j = i < n ? i : 2 * n - 1 - i;
        while (
            hull.length >= 2 &&
            removeMiddle(
                hull[hull.length - 2],
                hull[hull.length - 1],
                inputPoints[j]
            )
        )
            hull.pop();
        hull.push(inputPoints[j]);
    }

    hull.pop();
    return hull;
}

function removeMiddle(a: Point, b: Point, c: Point) {
    var cross = (a.x - b.x) * (c.y - b.y) - (a.y - b.y) * (c.x - b.x);
    var dot = (a.x - b.x) * (c.x - b.x) + (a.y - b.y) * (c.y - b.y);
    return cross < 0 || (cross === 0 && dot <= 0);
}

export function isPointInsideConvexHull(point: Point, hull: Point[]): boolean {
    for (let i = 0; i < hull.length; i++) {
        const p1 = hull[i];
        const p2 = hull[(i + 1) % hull.length]; // Wrap around to the first point

        const edge = { x: p2.x - p1.x, y: p2.y - p1.y };
        const toPoint = { x: point.x - p1.x, y: point.y - p1.y };
        const crossProduct = edge.x * toPoint.y - edge.y * toPoint.x;

        // If the cross product is positive, the point is outside
        if (crossProduct > 0) {
            return false;
        }
    }

    // If the point is on the same side of all edges, it is inside
    return true;
}
